import{create_ssr_component as l,escape as o}from"svelte/internal";const v=l((r,t,a,u)=>{let{value:e}=t;return t.value===void 0&&a.value&&e!==void 0&&a.value(e),`${o(e||"")}`});export{v as default};
//# sourceMappingURL=Example.js.map
